export const PAGINATION = '/:page(\\d+)?/:itemsPerPage(\\d+)?';
export const ENTITY_ID = '/:id(\\d+)';
export const MAYBE_ENTITY_ID = '/:id(\\d+)?';
